module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/strong-title_48e50051a681ede4a9a67f08cd363332.png";